import { NgModule } from '@angular/core';
import { Routes, RouterModule, Data } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { IndexLoggedinComponent } from './index-loggedin/index-loggedin.component';
import { GuardGuard, iGuard } from './guard.guard';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { QuicklinkStrategy } from 'ngx-quicklink';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    canActivate: [GuardGuard],
    data: <Data & { guard: iGuard }>{
      guard: { loggedin: false, redirect: ['/pages'] }
    }
  },
  {
    path: 'signin',
    loadChildren: () => import('./signin/signin.module').then(m => m.SigninModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'access-recovery',
    loadChildren: () => import('./recovery/recovery.module').then(m => m.RecoveryModule)
  },
  {
    path: 'pages',
    component: IndexLoggedinComponent,
    canActivate: [GuardGuard],
    data: <Data & { guard: iGuard }>{ guard: { loggedin: true, redirect: ['/'] } }
  },
  {
    path: 'user',
    canActivate: [GuardGuard],
    data: <{ guard: iGuard }>{ guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'leket',
    loadChildren: () => import('./leket/leket.module').then(m => m.LeketModule)
  },
  {
    path: 'hamal',
    canActivate: [GuardGuard],
    data: <{ guard: iGuard }>{ guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./hamal/hamal.module').then(m => m.HamalModule)
  },
  {
    path: 'social-media',
    canActivate: [GuardGuard],
    data: { guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./social-media/social-media.module').then(m => m.SocialMediaModule)
  },
  {
    path: 'digital',
    canActivate: [GuardGuard],
    data: { guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./digital/digital.module').then(m => m.DigitalModule)
  },
  {
    path: 'hasrata',
    canActivate: [GuardGuard],
    data: { guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./visual/visual.module').then(m => m.VisualModule)
  },
  {
    path: 'campaigns',
    canActivate: [GuardGuard],
    data: { guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  {
    path: 'releases-management',
    canActivate: [GuardGuard],
    data: { guard: { loggedin: true, redirect: ['/'] } },
    loadChildren: () => import('./releases/releases.module').then(m => m.ReleasesModule)
  },
  {
    path: 'recruitment',
    loadChildren: () => import('./recruitment/recruitment.module').then(m => m.RecruitmentModule)
  },
  {
    path: 'school',
    loadChildren: () => import('./school/school.module').then(m => m.SchoolModule)
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: QuicklinkStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
